<div class="drawer-conversations">
  <!-- LIST VIEW -->
  @if (viewMode === "list") {
    <div>
      <!-- Navigation par onglets -->
      <div class="drawer-conversations__header">
        <app-eva-tabs-navigation
          [tabs]="[
            { label: 'En cours', value: 'ongoing', icon: 'pi-comments' },
            { label: 'Archivées', value: 'archived', icon: 'pi-inbox' },
          ]"
          [activeTab]="activeTab"
          (tabChange)="onTabChange($event)"
        ></app-eva-tabs-navigation>
      </div>

      <!-- New conversation button -->
      <div class="conversations__create-button">
        <eva-dashed-add-button label="conversation" (buttonClick)="onCreateConversation()"></eva-dashed-add-button>
      </div>

      <!-- Liste de conversations -->
      <div class="conversations-list">
        <!-- Conversation 1: Équipe Chantier Lilas (unread) -->
        <div class="conversation-card unread" (click)="openConversation('conv-1')">
          <div class="conversation-header">
            <div class="conversation-avatars">
              <div class="avatar pink">PD</div>
              <div class="avatar blue">SH</div>
              <div class="avatar green">ML</div>
            </div>
            <div class="conversation-info">
              <div class="conversation-title">Équipe Chantier Lilas</div>
              <div class="conversation-preview">Simao: Ok pour le planning, je confirme ma présence vendredi</div>
            </div>
            <div class="conversation-meta">
              <div class="conversation-time">14:52</div>
              <div class="conversation-badge">2</div>
            </div>
          </div>
        </div>

        <!-- Conversation 2: Coordination Électricité -->
        <div class="conversation-card" (click)="openConversation('conv-2')">
          <div class="conversation-header">
            <div class="conversation-avatars">
              <div class="avatar orange">JD</div>
              <div class="avatar purple">AC</div>
            </div>
            <div class="conversation-info">
              <div class="conversation-title">Coordination Électricité</div>
              <div class="conversation-preview">Le fournisseur a confirmé la livraison pour mardi prochain</div>
            </div>
            <div class="conversation-meta">
              <div class="conversation-time">13:15</div>
            </div>
          </div>
        </div>

        <!-- Conversation 3: Marie Bonnet (unread) -->
        <div class="conversation-card unread" (click)="openConversation('conv-3')">
          <div class="conversation-header">
            <div class="conversation-avatars">
              <div class="avatar teal">MB</div>
            </div>
            <div class="conversation-info">
              <div class="conversation-title">Marie Bonnet (Architecte)</div>
              <div class="conversation-preview">
                J'ai envoyé les plans modifiés par email, peux-tu confirmer réception ?
              </div>
            </div>
            <div class="conversation-meta">
              <div class="conversation-time">11:30</div>
              <div class="conversation-badge">1</div>
            </div>
          </div>
        </div>

        <!-- Conversation 4: Direction -->
        <div class="conversation-card" (click)="openConversation('conv-4')">
          <div class="conversation-header">
            <div class="conversation-avatars">
              <div class="avatar red">PD</div>
              <div class="avatar yellow">LF</div>
              <div class="avatar blue">NG</div>
              <div class="avatar purple">TR</div>
            </div>
            <div class="conversation-info">
              <div class="conversation-title">Direction — Planning Q2</div>
              <div class="conversation-preview">Réunion de planification reportée au 15 mars</div>
            </div>
            <div class="conversation-meta">
              <div class="conversation-time">Hier</div>
            </div>
          </div>
        </div>

        <!-- Conversation 5: Client Dupont -->
        <div class="conversation-card" (click)="openConversation('conv-5')">
          <div class="conversation-header">
            <div class="conversation-avatars">
              <div class="avatar green">CD</div>
            </div>
            <div class="conversation-info">
              <div class="conversation-title">Client Dupont</div>
              <div class="conversation-preview">Merci pour le point, on se voit vendredi comme convenu</div>
            </div>
            <div class="conversation-meta">
              <div class="conversation-time">Lun</div>
            </div>
          </div>
        </div>

        <!-- Conversation 6: Fournisseurs Isolation -->
        <div class="conversation-card" (click)="openConversation('conv-6')">
          <div class="conversation-header">
            <div class="conversation-avatars">
              <div class="avatar orange">FB</div>
              <div class="avatar pink">LM</div>
            </div>
            <div class="conversation-info">
              <div class="conversation-title">Fournisseurs Isolation</div>
              <div class="conversation-preview">Offre reçu, je regarde ça demain matin</div>
            </div>
            <div class="conversation-meta">
              <div class="conversation-time">Ven</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- THREAD VIEW -->
  @if (viewMode === "thread") {
    <app-conversation-thread [conversationId]="currentConversationId" (backToList)="backToList()">
    </app-conversation-thread>
  }
</div>
